import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { applyIfExist, applyOr, updateProp } from '~/utils'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query StrategyMemoEditPage_Main($strategyMemoId: ID!) {
    customerStrategyMemo(id: $strategyMemoId) {
      id
      surveyId
      brandGroupId
      brandId
      countOfAnswers
      customFilter {
        filter {
          category
          question {
            questionId
            operation
            answerOptions {
              option
              text
            }
          }
          customerAttribute {
            customerAttributeIds
            operation
          }
          brandSegments {
            brandGroupId
            brandNumber
            segmentNumbers
          }
        }
      }
      dataDisplayType
      title
      goal
      strategies {
        id
        strategyType
        showArrow
        segmentRoutes {
          toSegmentNumber
          fromSegmentNumber
        }
        who
        what
        how
      }
      updatedAt
    }
  }
`)

export const useMainQuery = () => {
  const queryKey = useMainQueryKey()
  const graphQLRequest = useGraphQLRequest()
  const [_, variables] = queryKey

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({ document, variables })

      return R.pipe(
        result.customerStrategyMemo,
        applyIfExist(
          R.piped(
            updateProp(
              'strategies',
              applyOr(
                R.map(
                  updateProp(
                    'segmentRoutes',
                    (segmentRoutes) => segmentRoutes ?? [],
                  ),
                ),
                [],
              ),
            ),
          ),
        ),
      )
    },
    queryKey,
  })
}

export type StrategyMemo = NonNullable<QueryResultOf<typeof useMainQuery>>
